import Vue from 'vue'
import i18n from './index'

const getTranslation = new Vue({
  i18n,
  methods: {
    getTranslation(key) {
      return this.$t(key)
    }
  }
}).getTranslation

export default getTranslation
